import React from 'react';

import { ButtonTypes, IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { Piwik } from '../types';

import './SwapButton.scss';

interface SwapButtonProps {
    swapCurrencies: () => void;
    piwik: Piwik | undefined;
}

const SwapButton = ({ swapCurrencies, piwik }: SwapButtonProps) => (
    <IconButton
        screenReaderText="Swap currencies"
        buttonType={ButtonTypes.ICON_NEGATIVE}
        className="swap-icon-button"
        data-track-id={piwik?.visaCalculator?.visaExchangeCalculatorSwapCurrencies?.dataTrackId}
        data-track-linkname={piwik?.visaCalculator?.visaExchangeCalculatorSwapCurrencies?.dataTrackLinkname}
        icon={IconTypes.BEVEGELSER_24}
        id={piwik?.visaCalculator?.visaExchangeCalculatorSwapCurrencies?.dataTrackId}
        onClick={() => swapCurrencies()}
    />
);

export default SwapButton;
